(function () {
  var names = {
    'babyLivia Long Sleeve smekke': 'Long sleeve smekke',
    'babyLivia High neck smekke 2-pak': 'High neck smekke 2-pak'
  };
  function label(root) {
    root.querySelectorAll('.jdgm-carousel-item__product').forEach(function (el) {
      if (el.dataset.blDone) return;
      var img = el.querySelector('img');
      var text;
      if (img) {
        var t = img.getAttribute('alt') || '';
        text = names[t] || t.replace(/^babyLivia\s*/, '');
      } else {
        text = 'Nettbutikken';
      }
      el.dataset.blDone = '1';
      var s = document.createElement('span');
      s.className = 'bl-review-model';
      s.textContent = text;
      el.appendChild(s);
    });
  }
  function more(root) {
    root.querySelectorAll('.jdgm-carousel-item').forEach(function (it) {
      if (it.dataset.blMore) return;
      var body = it.querySelector('.jdgm-carousel-item__review-body');
      var title = it.querySelector('.jdgm-carousel-item__review-title');
      if (!body || body.clientHeight === 0) return;
      var cut = body.scrollHeight > body.clientHeight + 2 || (title && title.scrollHeight > title.clientHeight + 2);
      if (!cut) return;
      it.dataset.blMore = '1';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bl-review-more';
      b.textContent = 'Les hele omtalen';
      b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = it.classList.toggle('bl-open');
        b.textContent = open ? 'Vis mindre' : 'Les hele omtalen';
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      body.parentNode.insertBefore(b, body.nextSibling);
    });
  }
  function run() { label(document); more(document); }
  function start() {
    run();
    var mo = new MutationObserver(run);
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
    window.addEventListener('resize', function () { more(document); });
    window.addEventListener('load', function () { more(document); });
    [800, 2000, 4000].forEach(function (t) { setTimeout(function () { more(document); }, t); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
